import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

export type AccessDeniedModalProps = {
	/**
	 * State setter to hide the modal
	 */
	setShow: Dispatch<SetStateAction<boolean>>;

	/**
	 * The environment that returned the access denied error
	 */
	environment: string;
};

export const AccessDeniedModal = (props: AccessDeniedModalProps): JSX.Element => {
	const { t } = useTranslation();

	return (
		<div className="modal">
			<div className="modal-backdrop"></div>
			<div className="modal-window">
				<div className="modal-header">
					<div className="modal-title">{t("ACCESS_DENIED", { ns: "common" })}</div>
					<button onClick={() => props.setShow(false)} title="Sluiten" className="modal-close">
						<i className="icon icon-cross"></i>
					</button>
				</div>
				<div className="modal-body">
					<p>
						{t("ACCESS_DENIED_MESSAGE")} <strong>{props.environment}</strong>.
					</p>
					<p>
						{t("ACCESS_DENIED_CONTACT")}
					</p>
					<div className="modal-buttons align-center">
						<button
							className="button button-small button-primary button-icon"
							onClick={() => props.setShow(false)}
						>
							<i className="icon icon-cross"></i> {t("CLOSE_TAB")}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
